module.exports = __webpack_public_path__ + "static/img/detail_gametable_02.cd4b025.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/game-table/detail_gametable_02.jpg
// module id = 242
// module chunks = 2